var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6C6 5.72386 6.22386 5.5 6.5 5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5C6.22386 6.5 6 6.27614 6 6ZM6.5 7.5C6.22386 7.5 6 7.72386 6 8C6 8.27614 6.22386 8.5 6.5 8.5H8.5C8.77614 8.5 9 8.27614 9 8C9 7.72386 8.77614 7.5 8.5 7.5H6.5ZM8.00001 1C4.68631 1 2.00001 3.68629 2.00001 7C2.00001 8.03957 2.2648 9.01862 2.73086 9.87202L2.01925 12.3626C1.9683 12.541 2.02025 12.7329 2.15422 12.8612C2.2882 12.9894 2.48217 13.033 2.65813 12.9743L4.99618 12.195C5.87989 12.707 6.90639 13 8.00001 13C11.3137 13 14 10.3137 14 7C14 3.68629 11.3137 1 8.00001 1ZM3.00001 7C3.00001 4.23858 5.23859 2 8.00001 2C10.7614 2 13 4.23858 13 7C13 9.76142 10.7614 12 8.00001 12C7.01533 12 6.09854 11.7159 5.32536 11.2253C5.19843 11.1448 5.04199 11.1256 4.89938 11.1732L3.24119 11.7259L3.75014 9.94458C3.78797 9.81217 3.76952 9.67002 3.69913 9.55165C3.25513 8.80506 3.00001 7.93308 3.00001 7ZM12.2764 14.9472L9.87445 13.7462C10.3142 13.6243 10.7366 13.4605 11.137 13.2594L12.5 13.9409L17 11.6909V11C17 10.4477 16.5523 10 16 10H14.3264C14.4787 9.67933 14.6074 9.34525 14.7101 9H16C17.1046 9 18 9.89543 18 11V16C18 17.1046 17.1046 18 16 18H9C7.89543 18 7 17.1046 7 16V13.9291C7.3266 13.9758 7.66048 14 8 14V16C8 16.5523 8.44772 17 9 17H16C16.5523 17 17 16.5523 17 16V12.809L12.7236 14.9472C12.5828 15.0175 12.4171 15.0175 12.2764 14.9472Z",
    fill: "#262626"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogout);
export default __webpack_public_path__ + "static/media/dogout.7f03cbb1541aa91a387c0d0639453805.svg";
export { ForwardRef as ReactComponent };